// extracted by mini-css-extract-plugin
export default {"wrapper":"DefaultLayout_wrapper__3FkCL","container":"DefaultLayout_container__cbPg5","content":"DefaultLayout_content__cQGIN"};